import React from "react";
import { Box } from "@mui/material";
import { Page } from "../components/Page";
import { ToolCatalog } from "./ToolCatalog";

export function ToolList() {
  return (
    <Page
      title="Tools"
      description="Web-based utility tools for compression, encoding, benchmarking, and more"
    >
      <Box sx={{ maxWidth: "1200px", margin: "0 auto" }}>
        <ToolCatalog />
      </Box>
    </Page>
  );
}
